import * as yup from 'yup';

export const validationSchema = yup.object().shape({
  payload: yup.string().nullable(true).test("json", "Invalid JSON format", (value) => {
    try {
      JSON.parse(value);
      return true;
    } catch (error) {
      return false;
    }
  }),
});
